<template>
  <el-aside class="leftMenuBox pcShow" :width="isCollapse ? '50px' : '200px'" style="overflow-y: hidden;">
    <div class="" style="overflow-x: hidden">
      <div class="navTopLine">
        <div v-show="!isCollapse" class="navTopItem" @click="logout">
<!--          <img :src="require('@/assets/img/leftBar/logout.svg')" alt="">-->
          <SvgIcon name="logout" size="20" color="#f9c901" />
        </div>
        <div @click="toMenu({title:'修改密碼', index: '/editPwd', closable: true})" v-show="!isCollapse" class="navTopItem">
<!--          <img :src="require('@/assets/img/leftBar/editPwd.svg')" alt="">-->
          <SvgIcon name="key" size="20" color="#f9c901" />
        </div>
        <div @click="toMenu({title:'公告版', index: '/', changeBar: false})" v-show="!isCollapse" class="navTopItem">
<!--          <img :src="require('@/assets/img/leftBar/post.svg')" alt="">-->
          <SvgIcon name="post" size="20" color="#f9c901" />
        </div>
        <div v-show="!isCollapse" class="navTopItem">
          <img width="28px" height="28px" :src="require('@/assets/img/lang.png')" alt="">
        </div>
        <div @click="isCollapse = !isCollapse" :class="isCollapse ? 'push' : 'pull'" class="navTopItem">
<!--          <img :src="require('@/assets/img/leftBar/arrow.svg')" alt="">-->
          <SvgIcon name="arrow" size="20" color="#f9c901" />
        </div>
      </div>
      <div class="searchTabBox" style="padding: 10px 6px" v-if="!isCollapse">
        <div class="searchTab">
          <div @click="checkSearchType(1)" :class="searchType === 1 ? 'activeSearch' :''" class="searchTabItem">代理</div>
          <div @click="checkSearchType(2)" :class="searchType === 2 ? 'activeSearch' :''" class="searchTabItem">玩家</div>
          <div @click="checkSearchType(3)" :class="searchType === 3 ? 'activeSearch' :''" class="searchTabItem">子帳號</div>
        </div>
        <el-input
            v-model="searchInput"
            style="max-width: 200px"
            class="input-with-select"
        >
          <template #append>
            <el-button @click="searchFun()" >
              <template #icon>
                <SvgIcon name="search" size="15" color="#000" />
              </template>
            </el-button>
          </template>
        </el-input>
      </div>
      <el-menu
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
          text-color="#fff"
          active-text-color="#ffd04b"
          background-color="#444"
          :router="true"
          :default-active="$route.path"
      >
        <!--      <el-menu-item @click="toMenu('/')" index="1">-->
        <!--        <img class="leftIcon" :src="require('@/assets/img/leftBar/menu1.svg')" alt="">-->
        <!--        <template #title>下級代理管理</template>-->
        <!--      </el-menu-item>-->
        <el-menu-item v-for="(menuItem,index) in menuList" :class="menuItem.mobileShow ? 'mobileShow' : ''" :key="index" @click="toMenu(menuItem)" :index="menuItem.index">

          <div class="leftIcon" >
            <SvgIcon :name="menuItem.svg" size="16" color="#f9c901" />
          </div>
<!--          <img class="leftIcon" :src="menuItem.img" alt="">-->
          <template #title>{{ menuItem.tabTitle }}</template>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="manageBox" v-show="showManage">
      <div @click="showManage = false" class="manageBar">
        <el-icon><ArrowLeftBold /></el-icon>
        下線代理管理
      </div>
      <div class="manageTree">
        <el-tree
            style="max-width: 600px"
            :data="treeData"
            :props="defaultProps"
            :default-expanded-keys="[myUserId]"
            :current-node-key="myUserId"
            node-key="id"
            accordion
            @node-click="handleNodeClick"
        >
          <template #default="slotProps">
            <div class="custom-tree-node">
              <span class="node-label">{{ slotProps.node.label }}</span>
              <span v-if="slotProps.data.parent_agent" class="node-info">({{ slotProps.data.children.length }})</span>
            </div>
          </template>
        </el-tree>
      </div>
    </div>
  </el-aside>
  <el-aside class="leftMenuBox mobileShow" :class="isMobileCollapse ? 'mobileMenuWidth' : ''" :width="isMobileCollapse ? '50px' : '200px'" style="overflow-y: hidden;">
    <div class="" style="overflow-x: hidden">
      <div class="navTopLine pcShow">
        <div v-show="!isMobileCollapse" class="navTopItem" @click="logout">
<!--          <img :src="require('@/assets/img/leftBar/logout.svg')" alt="">-->
          <SvgIcon name="logout" size="20" color="#f9c901" />
        </div>
        <div @click="mobileToMenu({title:'修改密碼', index: '/editPwd', closable: true})" v-show="!isMobileCollapse" class="navTopItem">
<!--          <img :src="require('@/assets/img/leftBar/editPwd.svg')" alt="">-->
          <SvgIcon name="key" size="20" color="#f9c901" />
        </div>
        <div @click="mobileToMenu({title:'公告版', index: '/', changeBar: false})" v-show="!isMobileCollapse" class="navTopItem">
<!--          <img :src="require('@/assets/img/leftBar/post.svg')" alt="">-->
          <SvgIcon name="post" size="20" color="#f9c901" />
        </div>
        <div v-show="!isMobileCollapse" class="navTopItem">
          <img width="28px" height="28px" :src="require('@/assets/img/lang.png')" alt="">
        </div>
        <div @click="isMobileCollapse = !isMobileCollapse" :class="isMobileCollapse ? 'push' : 'pull'" class="navTopItem">
<!--          <img :src="require('@/assets/img/leftBar/arrow.svg')" alt="">-->
          <SvgIcon name="arrow" size="20" color="#f9c901" />
        </div>
      </div>
      <div class="searchTabBox" style="padding: 10px 6px" v-if="!isMobileCollapse">
        <div class="searchTab">
          <div @click="checkSearchType(1)" :class="searchType === 1 ? 'activeSearch' :''" class="searchTabItem">代理</div>
          <div @click="checkSearchType(2)" :class="searchType === 2 ? 'activeSearch' :''" class="searchTabItem">玩家</div>
          <div @click="checkSearchType(3)" :class="searchType === 3 ? 'activeSearch' :''" class="searchTabItem">子帳號</div>
        </div>
        <el-input
            v-model="searchInput"
            style="max-width: 200px"
            class="input-with-select"
        >
          <template #append>
            <el-button @click="searchFun()" >
              <template #icon>
                <SvgIcon name="search" size="15" color="#000" />
              </template>
            </el-button>
          </template>
        </el-input>
      </div>
      <el-menu
          class="el-menu-vertical-demo"
          :collapse="isMobileCollapse"
          text-color="#fff"
          active-text-color="#ffd04b"
          background-color="#444"
          :router="true"
          :default-active="$route.path"
      >
        <!--      <el-menu-item @click="toMenu('/')" index="1">-->
        <!--        <img class="leftIcon" :src="require('@/assets/img/leftBar/menu1.svg')" alt="">-->
        <!--        <template #title>下級代理管理</template>-->
        <!--      </el-menu-item>-->
        <el-menu-item v-for="(menuItem,index) in menuList" :class="menuItem.mobileShow ? 'mobileShow' : ''" :key="index" @click="mobileToMenu(menuItem)" :index="menuItem.index">

          <div class="leftIcon" >
            <SvgIcon :name="menuItem.svg" size="16" color="#f9c901" />
          </div>
<!--          <img class="leftIcon" :src="menuItem.img" alt="">-->
          <template #title>{{ menuItem.tabTitle }}</template>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="manageBox" v-show="showManage">
      <div @click="showManage = false" class="manageBar">
        <el-icon><ArrowLeftBold /></el-icon>
        下線代理管理
      </div>
      <div class="manageTree">
        <el-tree
            style="max-width: 600px"
            :data="treeData"
            :props="defaultProps"
            :default-expanded-keys="[myUserId]"
            :current-node-key="myUserId"
            node-key="id"
            accordion
            @node-click="handleNodeClick"
        >
          <template #default="slotProps">
            <div class="custom-tree-node">
              <span class="node-label">{{ slotProps.node.label }}</span>
              <span v-if="slotProps.data.parent_agent" class="node-info">({{ slotProps.data.children.length }})</span>
            </div>
          </template>
        </el-tree>
      </div>
    </div>
  </el-aside>
</template>
<script>
import { onMounted, reactive, toRefs, watch } from 'vue'
import {
  ArrowLeftBold
} from '@element-plus/icons-vue'
import api from '@/js/api.js'
import { useRouter } from "vue-router";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'leftBar',
  components: {
    ArrowLeftBold
  },
  emit: ['viewPath'],
  props: {
    showManu: {
      default: true
    }
  },
  setup(props, context) {
    const data = reactive({
      myUserId: localStorage.getItem('id'),
      isCollapse : true,
      isMobileCollapse : true,
      active: '1',
      menuList: [
        {
          title: '下線代理管理',
          tabTitle: '下線代理管理',
          img: require('@/assets/img/leftBar/menu1.svg'),
          svg: 'tree',
          index: '',
          changeBar: true
        },
        {
          title: '代理組織圖',
          tabTitle: '代理組織圖',
          img: require('@/assets/img/leftBar/menu1.svg'),
          svg: 'top',
          index: '/ManagementTree',
          closable: true
        },
        {
          title: '輸贏報表-'+ localStorage.getItem('username'),
          tabTitle: '輸贏報表',
          img: require('@/assets/img/leftBar/menu2.svg'),
          svg: 'winLossReportIcon',
          index: '/winorlose?id='+ localStorage.getItem('id'),
          closable: true
        },
        {
          title: '玩家投注分析',
          tabTitle: '玩家投注分析',
          img: require('@/assets/img/leftBar/menu3.svg'),
          svg: 'memberBetAnalysis',
          index: '/betAnalysis',
          closable: true
        },
        {
          title: '投注記錄',
          tabTitle: '投注記錄',
          img: require('@/assets/img/leftBar/menu4.svg'),
          svg: 'memberBet',
          index: '/memberBet',
          closable: true
        },
        {
          title: '游戲結果',
          tabTitle: '游戲結果',
          img: require('@/assets/img/leftBar/menu5.svg'),
          svg: 'poker',
          index: '/gameResult',
          closable: true
        },
        {
          title: '代理額度記錄',
          tabTitle: '代理額度記錄',
          img: require('@/assets/img/leftBar/menu6.svg'),
          svg: 'agentBalanceRecordIcon',
          index: '/actingLog',
          closable: true
        },
        {
          title: '玩家額度記錄',
          tabTitle: '玩家額度記錄',
          img: require('@/assets/img/leftBar/menu7.svg'),
          svg: 'memberBalanceRecordIcon',
          index: '/balanceRecord',
          closable: true
        },
        {
          title: '代理商額度報表',
          tabTitle: '代理商額度報表',
          img: require('@/assets/img/leftBar/menu8.svg'),
          svg: 'agentBalanceReportIcon',
          index: '/balanceReport',
          closable: true
        },
        // {
        //   title: '代理纍計報表',
        //   img: require('@/assets/img/leftBar/menu2.svg'),
        // svg: 'winLossReportIcon',
        //   index: '/agentMonthReport',
        //   closable: true
        // },
        {
          title: '贈禮記錄',
          tabTitle: '贈禮記錄',
          img: require('@/assets/img/leftBar/menu9.svg'),
          svg: 'redEnvelope',
          index: '/giftRecord',
          closable: true
        },
        {
          title: '登入IP白名單',
          tabTitle: '登入IP白名單',
          img: require('@/assets/img/leftBar/menu10.svg'),
          svg: 'ipWhitelistIcon',
          index: '/ipWhitelist',
          closable: true
        },
        {
          title: 'IP查詢',
          tabTitle: 'IP查詢',
          img: require('@/assets/img/leftBar/menu10.svg'),
          svg: 'menu10',
          index: '/ipSearch',
          closable: true
        },
        {
          title: '操作日志',
          tabTitle: '操作日志',
          img: require('@/assets/img/leftBar/menu11.svg'),
          svg: 'operationLogIcon',
          index: '/logManagement',
          closable: true
        },
        {
          title: '修改密碼',
          tabTitle: '修改密碼',
          img: require('@/assets/img/leftBar/key.svg'),
          svg: 'key',
          index: '/editPwd',
          closable: true,
          mobileShow: true
        },
        {
          title: '登出',
          tabTitle: '登出',
          img: require('@/assets/img/leftBar/logout.svg'),
          svg: 'logout',
          index: '/login',
          closable: true,
          mobileShow: true
        }
      ],
      showManage: false,
      treeData: [
        // {
        //   id: 1,
        //   label: '一级 1',
        //   children: [
        //     {
        //       id: 4,
        //       label: '二级 1-1',
        //       children: [
        //         {
        //           id: 9,
        //           label: '三级 1-1-1'
        //         },
        //         {
        //           id: 10,
        //           label: '三级 1-1-2'
        //         }
        //       ]
        //     }
        //   ]
        // },
        // {
        //   id: 2,
        //   label: '一级 2',
        //   children: [
        //     {
        //       id: 5,
        //       label: '二级 2-1'
        //     },
        //     {
        //       id: 6,
        //       label: '二级 2-2'
        //     }
        //   ]
        // },
        // {
        //   id: 3,
        //   label: '一级 3',
        //   children: [
        //     {
        //       id: 7,
        //       label: '二级 3-1'
        //     },
        //     {
        //       id: 8,
        //       label: '二级 3-2'
        //     }
        //   ]
        // }
      ],
      defaultProps: {
        children: 'children',
        label: 'username'
      },
      treeRef: null,
      searchInput: '',
      searchType: 1
    })// 数据
    // 子组件中触发事件
    // const emit = defineEmits(['viewPath'])
    const { push } = useRouter()
    const methods = {
      searchFun () {
        var obj = {
          username: localStorage.getItem('username'),
          id: localStorage.getItem('id'),
          search: data.searchInput,
          type: data.searchType
        }
        methods.handleNodeClick(obj)
      },
      checkSearchType (type) {
        data.searchType = type
      },
      mobileToMenu (router) {
        if (router.index === '/login') {
          methods.logout()
        }
        if (router.changeBar) {
          data.showManage = true
        }else {
          sessionStorage.setItem('nowRouter', router.index)
          data.isMobileCollapse = true
          context.emit('viewPath', router)
          push(router.index)
        }
      },
      toMenu (router) {
        if (router.changeBar) {
          data.showManage = true
        }else {
          sessionStorage.setItem('nowRouter', router.index)
          context.emit('viewPath', router)
          push(router.index)
        }
      },
      handleNodeClick (dataObj, node) {
        var menageTab = {
          title: '代理管理',
          index: '/agentManagement',
          closable: true
        }

        console.log('节点被点击:', dataObj)
        console.log('节点对象:', node)
        if(dataObj.id != undefined) {
          menageTab.title += '-' + dataObj.username
          menageTab.index += '?id=' + dataObj.id
        }
        if(dataObj.search != undefined) {
          // localStorage.setItem('searchUsername', dataObj.search)
          menageTab.search = dataObj.search
          // provide('searchUsername', dataObj.search)
        }
        if(dataObj.type != undefined) {
          // localStorage.setItem('searchType', dataObj.type)
          menageTab.type = dataObj.type
          // provide('searchType', dataObj.type)
        }
        console.log(menageTab)
        methods.toMenu(menageTab)
        methods.mobileToMenu(menageTab)
        // push('/agentManagement')
      },
      getCheckedNodes () {
        if (data.treeRef) {
          const checkedNodes = data.treeRef.getCheckedNodes()
          console.log('选中的节点:', checkedNodes)
        }
      },
      getTree() {
        api.post('tree', {
          requestName: 'tree'
        }).then(res => {
          if (res.data.result !== undefined && res.data.status === 'M00000') {
            var newTreeData = res.data.result
            var children = []
            for (var i = 0;i < newTreeData[0].children.length; i++) {
              if (newTreeData[0].children[i].parent_agent) {
                children.push(newTreeData[0].children[i])
              }
            }
            newTreeData[0].children = children
            data.treeData = newTreeData
            localStorage.setItem('agentTree', JSON.stringify(res.data.result))
          }
        })
      },
      logout() {
        // localStorage.removeItem('token')
        // localStorage.removeItem('username')
        window.location.href="/login"
        setTimeout(()=>{
          localStorage.clear()
        },500)
      }
  }
    // 事件
    onMounted(()=>{
      methods.getTree()
    })

    watch(() => props.showManu, () => {
      data.isMobileCollapse = !data.isMobileCollapse
    })

    return {
      ...toRefs(data),
      // ...emit,
      ...methods
    }
  }
}
</script>
<style scoped lang="scss">
@media only screen and (max-width: 991px) {
  .leftMenuBox {
    position: absolute !important;
    height: 100%;
    z-index: 100;
  }
  .mobileMenuWidth {
    width: 0;
    border-right: unset !important;
  }
  .pcShow {
    display: none;
  }
}
.custom-tree-node {
  color: #fff !important;
}
.manageTree {
  margin-top: 15px;
}
.el-tree {
  --el-tree-node-content-height: 32px;
}
//::v-deep .is-focusable{
//  background-color: #444 !important;
//}
::v-deep .el-tree-node.is-current .el-tree-node__content{
  background-color: #444 !important;
}
//::v-deep .is-current{
//  background-color: #444 !important;
//}
::v-deep .is-current>.el-tree-node__content>.custom-tree-node{
  color: var(--main-color) !important;
}
::v-deep .el-text {
  font-size: 14px;
}
::v-deep .el-tree-node__content>.el-tree-node__expand-icon {
  color: var(--main-color);
  font-size: 18px;
}
::v-deep .el-tree-node__expand-icon.is-leaf {
  visibility: unset !important;
}

.home-icon {
  color: red;
  font-size: 24px;
}
.searchTab {
  display: flex;
  justify-content: space-between;
}
.searchTabItem {
  color: #fff;
  flex-basis: 33.333%;
  text-align: center;
  font-size: 14px;
  padding: 5px 0;
  position: relative;
  bottom: -2px;
  cursor: pointer;
}
.activeSearch {
  background: var(--main-color);
  color: #000;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 2px solid var(--main-color);
}

::v-deep .input-with-select .el-input__wrapper{
  border: 2px solid var(--main-color);
  box-shadow: unset !important;
}
::v-deep .input-with-select .el-input-group__append{
  border: 2px solid var(--main-color);
  box-shadow: unset !important;
}
::v-deep .el-input-group__append {
  width: 50px;
  background: var(--main-color);
}
.el-aside {
  background-color: #000;
  border-right: 2px solid var(--main-color);
  transition: all .3s;
  animation-duration: .3s;
  position: relative;
}
.el-menu {
  background: unset;
}
.el-menu-item.is-active {
  color: var(--main-color);
}
.searchTabBox {
  position: relative;
}
.searchTabBox::after {
  height: 0;
  border-bottom: 1px solid #444;
  content: "";
  position: absolute;
  width: calc(100% - 20px);
  left: 10px;
  bottom: 1px;
}
.el-menu-item::after {
  height: 0;
  border-bottom: 1px solid #444;
  content: "";
  position: absolute;
  width: calc(100% - 20px);
  left: 10px;
  bottom: 1px;
}
.el-menu-item {
  //border-bottom: 1px solid #444;
  padding: 13px 10px;
  height: auto;
  line-height: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 13px;
  font-weight: normal;
}
::v-deep .el-menu-item .el-menu-tooltip__trigger {
  height: auto;
  position: relative !important;
  padding: unset !important;
}
.leftIcon {
  margin-right: 5px;
  width: 24px;
  text-align: center;
}

.el-menu--collapse {
  width: 100%!important;
}

::v-deep .el-menu-item {
  padding: 13px 10px !important;
//  padding: 10px 0!important;
//  display: flex;
//  align-items: center;
//  justify-content: center;
//  .leftIcon {
//    margin-right: unset!important;
//  }
}

.manageBox {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: black;
  transition: all .3s;
  color: #fff;
  padding-top: 11px;

  .manageBar {
    cursor: pointer;
    border-bottom: .08333rem solid #4e4e4e;
    height: 40px;
    line-height: 40px;
    padding-left: 6px !important;
    font-size: 14px;
  }
}
.el-tree {
  background: unset !important;
}
::v-deep .el-tree-node__content:hover {
  background-color: #444 !important;
}
::v-deep .el-text {
  color: #fff !important;
}

@keyframes showManage {
  0% {

  }
  50% {

  }
  100% {

  }
}

.navTopLine {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #444;
  padding: 2px 0;
  .navTopItem {
    width: 25%;
    height: 38px;
    padding: 2px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #444;
    transition: all .3s;
    animation-duration: .3s;
    cursor: pointer;
    svg {
      transition: all .3s;
      animation-duration: .3s;
    }
  }

  .navTopItem:last-child {
  }

  .pull {
    //border-right: 2px solid var(--main-color);
    svg {
      transform: rotate(360deg);
    }
  }

  .push {
    width: 100%!important;
    //transform: rotate(180deg);
    svg {
      transform: rotate(180deg);
    }
  }
}
</style>
